"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _axios = _interopRequireDefault(require("axios"));

var _Voucher = _interopRequireDefault(require("./Voucher"));

var _VoucherActions = _interopRequireDefault(require("./VoucherActions"));

var _VoucherContent = _interopRequireDefault(require("./VoucherContent"));

var _VoucherImage = _interopRequireDefault(require("./VoucherImage"));

var _VoucherText = _interopRequireDefault(require("./VoucherText"));

var _VoucherSkeleton = _interopRequireDefault(require("./VoucherSkeleton"));

var _WalletVoucherContainer = _interopRequireDefault(require("./WalletVoucherContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var skeletons = [1, 2, 3, 4];

var Wrapper = function Wrapper(_ref) {
  var onError = _ref.onError;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      transactions = _useState2[0],
      setTransactions = _useState2[1];

  var currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || "£";
  var voucherAmount = process.env.REACT_APP_VOUCHER_PRIZE_AMOUNT || 5;
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _transactionsRes$data, _transactionsRes$data2, transactionsRes, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios.default.get("/wallet/transactions?per_page=1000");

            case 3:
              transactionsRes = _context.sent;
              // setTimeout(() => {
              setTransactions(transactionsRes === null || transactionsRes === void 0 ? void 0 : (_transactionsRes$data = transactionsRes.data) === null || _transactionsRes$data === void 0 ? void 0 : (_transactionsRes$data2 = _transactionsRes$data.data) === null || _transactionsRes$data2 === void 0 ? void 0 : _transactionsRes$data2.filter(function (item) {
                return item.type === "UBER_VOUCHER";
              })); // }, 1000);

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              response = _context.t0.response;
              onError(response);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }, []);
  return (transactions === null || transactions === void 0 ? void 0 : transactions.length) > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, transactions.map(function (t) {
    var _t$document, _t$document$uber_vouc, _t$document$uber_vouc2, _t$document2, _t$document2$uber_vou, _t$document3, _t$document3$uber_vou, _t$document3$uber_vou2;

    return /*#__PURE__*/_react.default.createElement(_Voucher.default, null, /*#__PURE__*/_react.default.createElement(_VoucherImage.default, {
      voucherLink: t === null || t === void 0 ? void 0 : (_t$document = t.document) === null || _t$document === void 0 ? void 0 : (_t$document$uber_vouc = _t$document.uber_voucher_program) === null || _t$document$uber_vouc === void 0 ? void 0 : (_t$document$uber_vouc2 = _t$document$uber_vouc.code) === null || _t$document$uber_vouc2 === void 0 ? void 0 : _t$document$uber_vouc2.link
    }), /*#__PURE__*/_react.default.createElement(_VoucherContent.default, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: "10px"
      }
    }, /*#__PURE__*/_react.default.createElement(_VoucherText.default, {
      size: "xl"
    }, currencySymbol, voucherAmount, " off"), /*#__PURE__*/_react.default.createElement(_VoucherText.default, {
      size: "md",
      marginBottom: "8px"
    }, "your order")), /*#__PURE__*/_react.default.createElement(_VoucherText.default, {
      size: "sm",
      isLabel: true,
      marginBottom: "4px"
    }, "EXP", " ", /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.DateTime, {
      format: "DD/MM/YY"
    }, t === null || t === void 0 ? void 0 : (_t$document2 = t.document) === null || _t$document2 === void 0 ? void 0 : (_t$document2$uber_vou = _t$document2.uber_voucher_program) === null || _t$document2$uber_vou === void 0 ? void 0 : _t$document2$uber_vou.ends_at))), /*#__PURE__*/_react.default.createElement(_VoucherActions.default, {
      voucherCode: t === null || t === void 0 ? void 0 : (_t$document3 = t.document) === null || _t$document3 === void 0 ? void 0 : (_t$document3$uber_vou = _t$document3.uber_voucher_program) === null || _t$document3$uber_vou === void 0 ? void 0 : (_t$document3$uber_vou2 = _t$document3$uber_vou.code) === null || _t$document3$uber_vou2 === void 0 ? void 0 : _t$document3$uber_vou2.text
    }));
  })) : (transactions === null || transactions === void 0 ? void 0 : transactions.length) === 0 ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.EmptyScreen, {
    emptyIcon: "local_offer",
    emptyTitle: "No vouchers yet",
    emptySubtitle: "Enter a contest to win some!"
  }) : skeletons.map(function (s) {
    return /*#__PURE__*/_react.default.createElement(_VoucherSkeleton.default, {
      key: s
    });
  });
};

var _default = Wrapper;
exports.default = _default;